import { useMutation, UseMutationOptions } from 'react-query';

import { PaymentApi, VipDiscountActivationResponse } from 'api/PaymentApi';

export const useVipDiscountActivationMutation = (
  options?: UseMutationOptions<VipDiscountActivationResponse>
) => {
  return useMutation(PaymentApi.activateVipDiscount, options);
};
